import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { useDonationFormsStore } from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ZakatDonation',
  props: {
  postId: {
    type: Number,
    default: 0
  },
  currency: {
    type: String,
    default: 'USD'
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();

const props = __props;

const zakatAmount = ref(0);

// Watch for zakat amount updates from the calculator
const updateZakatAmount = () => {
  const zakatWrapper = document.querySelector('.lifeline-zakat-donation');
  if (zakatWrapper) {
    const amount = zakatWrapper.getAttribute('data-zakat-amount');
    if (amount) {
      zakatAmount.value = parseFloat(amount);
    }
  }
};

const openZakatModal = async () => {
  if (zakatAmount.value > 0) {
    // Initialize the donation store with Zakat data
    await store.getData({ 
      vm: { 
        id: props.postId,
        dstyle: 1
      } 
    });
    
    // Set Zakat-specific values
    store.amount = zakatAmount.value;
    store.extras.donation_purpose = 'Zakat';
    store.currency = props.currency;
    store.recurring = false; // Disable recurring for Zakat
    
    // Show the modal
    store.showModal = true;
  }
};

const closeModal = () => {
  store.showModal = false;
};

onMounted(() => {
  // Initial amount check
  updateZakatAmount();
  
  // Listen for zakat amount updates
  const observer = new MutationObserver(() => {
    updateZakatAmount();
  });
  
  const zakatWrapper = document.querySelector('.lifeline-zakat-donation');
  if (zakatWrapper) {
    observer.observe(zakatWrapper, {
      attributes: true,
      attributeFilter: ['data-zakat-amount']
    });
  }
});

const __returned__ = { store, props, zakatAmount, updateZakatAmount, openZakatModal, closeModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})